import { Link, Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Logo } from "./Logo";
import { useLaunchState, LaunchGate } from "./LaunchCountdown";

export const Footer = () => (
  <footer className="border-t border-[#1E281E] bg-[#080A08]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
      <div className="space-y-4">
        <Logo size="h-10" />
        <p className="font-display text-2xl font-bold uppercase tracking-tight">Analyze. Improve. Play Better.</p>
        <p className="text-sm text-[#7C8A7C]">Your Game. Your Data. Your Next Level.<br />By Buddy Innovations &amp; Technologies.</p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="eyebrow mb-3">Product</p>
        <a href="/#features" className="block text-[#A3ADA3] hover:text-white">Features</a>
        <a href="/#how-it-works" className="block text-[#A3ADA3] hover:text-white">How It Works</a>
        <a href="/#rewards" className="block text-[#A3ADA3] hover:text-white">Referral Rewards</a>
        <Link to="/faq" className="block text-[#A3ADA3] hover:text-white">FAQ</Link>
      </div>
      <div className="space-y-2 text-sm">
        <p className="eyebrow mb-3">Account &amp; Legal</p>
        <Link to="/dashboard" className="block text-[#A3ADA3] hover:text-white" data-testid="footer-stats-link">View My Stats</Link>
        <Link to="/email-preferences" className="block text-[#A3ADA3] hover:text-white">Email Preferences</Link>
        <Link to="/privacy" className="block text-[#A3ADA3] hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
        <Link to="/terms" className="block text-[#A3ADA3] hover:text-white" data-testid="footer-terms-link">Terms &amp; Reward Conditions</Link>
      </div>
    </div>
    <div className="border-t border-[#1E281E] py-6 text-center text-xs text-[#5E6B5E]">
      © {new Date().getFullYear()} Buddy Innovations &amp; Technologies. CricAnalyze is in development; previews shown are illustrative.
    </div>
  </footer>
);

const OPEN_PATHS = ["/privacy", "/terms", "/unsubscribe", "/email-preferences"];

export const SiteLayout = () => {
  const { pathname } = useLocation();
  const st = useLaunchState();
  if (st.loading) return <div className="min-h-screen bg-[#080A08]" />;
  if (st.locked && !OPEN_PATHS.includes(pathname)) return <LaunchGate diff={st.diff} launchAt={st.launchAt} />;
  return (
    <div className="min-h-screen flex flex-col bg-[#080A08]">
      <Navbar />
      <main className="flex-1 pt-[72px]"><Outlet /></main>
      <Footer />
    </div>
  );
};
